@let currency = account().currency;
@let isSelected = selected();

<div class="ci-wallet" [class.light]="!themeService.isDarkTheme()">
  <img class="ci-wallet-img" [src]="walletImgSrc()" [alt]="currency.name" />
  <fu-icon
    class="ci-wallet-currency"
    [iconName]="currency.symbol.toLowerCase()"
    [size]="20"
  />
  @if (!isSelected) {
    <fu-icon class="chosen-icon" iconName="succeeded" size="16" />
  }
</div>

<div class="ci-details">
  <div class="ci-details-title">
    {{ currency?.symbol }}
    <fu-icon class="arrow" iconName="arrow" size="20" />
  </div>

  @if (isSelected) {
    <p class="ci-details-message">
      {{ "accountWithAmount.currencyItem.selected.message" | translate }}

      <iw-tooltip
        class="ci-details-tooltip"
        [maxWidth]="180"
        position="tc"
        title="accountWithAmount.currencyItem.selected.tooltip"
      />
    </p>
  }
</div>
